import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { Search } from '@air/api';
import { type Board } from '@air/api/types';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const getPrivateExtensionsListKey = ({
  workspaceId,
  search,
  boardId,
  libraryId,
}: {
  workspaceId: string | undefined;
  search: string;
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
}) => ['EXTENSIONS', { workspaceId, search, boardId, libraryId }];

export const usePrivateExtensionsList = ({
  search,
  boardId,
  libraryId,
}: {
  search: string;
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
}) => {
  const { currentWorkspace } = useCurrentWorkspace();

  const key = getPrivateExtensionsListKey({ workspaceId: currentWorkspace?.id, search, boardId, libraryId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(currentWorkspace?.id, 'Workspace ID is required');

      const data = await Search.getAssetVersionFilterLookups({
        limit: 20,
        boardId,
        workspaceId: currentWorkspace.id,
        field: 'extension',
        search,
        libraryId,
      });

      return data.lookups.map((lookup) => lookup.value.toString());
    },
    enabled: !!currentWorkspace?.id,
  });
};
